export const SESSION_ID = Math.random().toString(36).slice(2, 10).toUpperCase()
